// Default toast options
import { toast } from "react-toastify";

const defaultOptions = {
  position: "top-right",
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  theme: "light",
  style: {
    fontFamily: "Lexend",
    fontSize: 14,
  },
};

export const showToastError = (message, options = {}) => {
  toast.error(message, { ...defaultOptions, ...options });
};

export const showToastError400 = (error, options = {}) => {
  const code = error.data?.data?.code;
  let message = error?.data?.data?.message;
  if (code === "CLIENT_EX002") {
    message = error?.data?.data?.message.split(",")[0];
  }

  toast.error(message, { ...defaultOptions, ...options });
};

export const showToastSuccess200 = (success, options = {}) => {
  let message = success.message;
  toast.success(message, { ...defaultOptions, ...options });
};

export const showToastSuccess = (message, options = {}) => {
  toast.success(message, { ...defaultOptions, ...options });
};

export const showToastInfo = (message, options = {}) => {
  toast.info(message, { ...defaultOptions, ...options });
};

export const showToastWarning = (message, options = {}) => {
  toast.warn(message, { ...defaultOptions, ...options });
};

export const ToastUtil = {
  showToastError,
  showToastSuccess,
  showToastInfo,
  showToastWarning,
  showToastError400,
  showToastSuccess200,
};
